module.exports = __webpack_public_path__ + "assets/table.475dc6d2.svg";